export const REGEX_COMPANY_NAME_VALIDATOR_PATTERN = /^\S+/;
export const REGEX_COMPANY_NAME_VALIDATOR_ERROR = 'Regular expression for company name validations not set';
/**
 * Explanation of the Company Validation Regex Pattern:
 *
 * - ^: Start of the string.
 * - \S: Matches any non-white-space character.
 * - +: Requires at least one non-white-space character.
 */
export class CompanyNameValidator {
    constructor(regex = REGEX_COMPANY_NAME_VALIDATOR_PATTERN) {
        this.regex = regex;
        if (!regex) {
            throw new Error(REGEX_COMPANY_NAME_VALIDATOR_ERROR);
        }
    }
    validate(companyName) {
        return this.regex.test(companyName);
    }
}
//# sourceMappingURL=CompanyNameValidator.js.map